import { useMemo } from 'react';

export type PpaScenarioMetadataField = {
    label: string;
    value: string;
};

export type PpaScenarioMetadataSummary = {
    fields: PpaScenarioMetadataField[];
};

const HARDCODED_SCENARIO_METADATA_SUMMARY: PpaScenarioMetadataSummary = {
    fields: [
        { label: 'Source', value: 'Circana' },
        { label: 'Simulation Period', value: '01/05/25 - 12/28/25' },
        { label: 'Channel', value: 'Some Value' },
        { label: 'Segment', value: 'Some Value' },
    ],
};

export function usePpaScenarioMetadataSummary(): PpaScenarioMetadataSummary {
    return useMemo(() => HARDCODED_SCENARIO_METADATA_SUMMARY, []);
}
